export default __webpack_public_path__ + "static/media/ico_arrow_right.9ddf2d8b.svg";